/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcInventoryV1BooksOrderEvent } from '@interxfi/types';
import { schema } from 'normalizr';
import { ixcAssetsV1AssetStateEntity } from './ixc-assets-v1-asset-state';

export const IXC_INVENTORY_V1_BOOKS_ORDER_EVENT_ENTITY_NAME = 'ixc.inventory.v1.BooksOrderEvent';
export const ixcInventoryV1BooksOrderEventEntity = new schema.Entity<IxcInventoryV1BooksOrderEvent>(IXC_INVENTORY_V1_BOOKS_ORDER_EVENT_ENTITY_NAME, {
    event: new schema.Object({
        requested: new schema.Object({
            asset: ixcAssetsV1AssetStateEntity
        })
    })
}, { idAttribute: (entity: IxcInventoryV1BooksOrderEvent) => `${entity.metadata?.eventId}` });

